import clsx from 'clsx'
import { useMemo } from 'react'
import { appDay } from 'shared/day'
import { formatDuration } from 'shared/time'
import { StackIcon } from 'shared/ui'

import type { CampaignStepType, StepExecution } from '../../types'

import { MessagePreview } from './MessagePreview'
import css from './UpcomingEvents.module.css'

const Text: Partial<Record<CampaignStepType, string>> = {
	Connect: 'Waiting for connect',
	EndorseSkill: 'Waiting for endorsing a skill',
	Follow: 'Waiting for following this contact',
	Message: 'Waiting for sending the ',
	ReactOnPost: 'Waiting for liking a post',
	ScrapeProfile: 'Waiting for scraping profile',
	VisitProfile: "Waiting for visiting contact's profile"
}

export function InQueueList({
	currentIndex,
	executionId,
	...step
}: StepExecution & {
	currentIndex: number
	executionId: string
}) {
	const duration = useMemo(() => {
		if (step.timeout && step.timeout > 0) {
			const value = appDay.duration({
				minutes: step.timeout
			})

			return formatDuration(value)
		}

		return null
	}, [step.timeout])

	return (
		<ol className={css.list}>
			{step.type && step.type in Text && (
				<li className={clsx(css.item, css.current)}>
					<StackIcon
						className={css.icon}
						icon='clock'
						stack='execution'
						width={16}
					/>

					{step.type === 'Message' ? (
						<span className={css.text}>
							{Text[step.type]}

							<MessagePreview execution={executionId} step={currentIndex} />
						</span>
					) : (
						Text[step.type]
					)}
				</li>
			)}

			<li className={css.item}>
				<StackIcon
					className={css.icon}
					icon='clock'
					stack='execution'
					width={16}
				/>
				Waiting for a reply
				{duration && <time className={css.timer}>{duration}</time>}
			</li>
		</ol>
	)
}
